import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { Tooltip } from 'antd';
import { preferredTemperatureUnit } from '../../../../utils';
import WaterTempIcon from '../../../icons/WaterTemp';
import CloseIcon from '../../../icons/Close';
import MapViewInfoIcon from '../../../icons/MapViewInfo';

const SurfaceWaterTemperatureMagnitude = (props) => {
  const {
    isActive,
    setIsActive,
    isSharing,
  } = props;

  const isMobile = useMediaQuery({ maxWidth: 767 }) && !isSharing;

  const tempRange = isMobile ? [29.5, 25.5, 20.5, 15.5, 10.5, 5.5, 0] : [29.5, 23.5, 19.5, 15.5, 10.5, 6.5, 0];

  const [rangeDisplay, setRangeDisplay] = useState(
    <>
      {tempRange.map((tempRange, index) => (
        <React.Fragment key={index}>
          {isMobile && (
            <div className="mobile-temp-legend-item">
              <span className="mobile-temp-legend-item-text">
                {preferredTemperatureUnit(tempRange)}
              </span>
            </div>
          )}
          {!isMobile && (
            <div className="temp-legend-item">
              <span className="temp-legend-item-text">
                {preferredTemperatureUnit(tempRange)}
              </span>
            </div>
          )}
        </React.Fragment>
      ))}
    </>,
  );

  // https://stackoverflow.com/questions/61178240/useeffect-does-not-listen-for-localstorage
  // https://stackoverflow.com/questions/56660153/how-to-listen-to-localstorage-value-changes-in-react
  useEffect(() => {
    function triggerSetRangeDisplay() {
      setRangeDisplay(
        <>
          {tempRange.map((tempRange, index) => (
            <React.Fragment key={index}>
              {isMobile && (
                <div className="mobile-temp-legend-item">
                  <span className="mobile-temp-legend-item-text">
                    {preferredTemperatureUnit(tempRange)}
                  </span>
                </div>
              )}
              {!isMobile && (
                <div className="temp-legend-item" key={index}>
                  <span className="temp-legend-item-text">
                    {preferredTemperatureUnit(tempRange)}
                  </span>
                </div>
              )}
            </React.Fragment>
          ))}
        </>,
      );
    }

    window.addEventListener('storage', triggerSetRangeDisplay);

    return () => {
      window.removeEventListener('storage', triggerSetRangeDisplay);
    };
  }, []);

  return (
    <>
      {isMobile
      && (
        <div className="mobile-temp-legend-container">
          <WaterTempIcon />
          <div>Water</div>
          <div>Temp</div>
          <div className="mobile-temp-legend">
            {rangeDisplay}
          </div>
        </div>
      )}
      {!isMobile
        && (
          <div className={`map-layer-card ${isActive ? 'active' : ''}`} onClick={() => { if (!isActive) { setIsActive(true); } }}>
            <div className="map-layer-title">
              <div className="map-layer-icons">
                <WaterTempIcon />
                <Tooltip
                  overlayClassName="omics-data-tooltip"
                  placement="right"
                  align={{ offset: [24, 0] }}
                  title="Surface water temperature map layer data are sourced from NOAA&apos;s Operational Forecast System"
                >
                  <MapViewInfoIcon className="info-button" style={!isActive ? {} : { display: 'none' }} />
                </Tooltip>
                <CloseIcon className="close-button" onClick={() => setIsActive(false)} style={isActive ? {} : { display: 'none' }} />
              </div>
              <div className="overlay-label">
                <div>Water</div>
                {' '}
                <div>Temp</div>
              </div>
            </div>
            <div className={`map-layer-content ${isActive ? 'active' : ''}`}>
              <div className="map-layer-legend-container">
                <div className="legend temp-legend">
                  {rangeDisplay}
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

SurfaceWaterTemperatureMagnitude.propTypes = {
  isActive: PropTypes.bool,
  setIsActive: PropTypes.func,
  isSharing: PropTypes.bool,
};

SurfaceWaterTemperatureMagnitude.defaultProps = {
  isActive: false,
  setIsActive: () => {},
  isSharing: false,
};

export default SurfaceWaterTemperatureMagnitude;
